import { formatPercent, formatRial } from '@kia/shared';
import { useMarginFloors } from '../config/ConfigProvider';
import { marginColor } from '../lib/margin';
import { pricingFor } from '../lib/pricing';

/**
 * Inline pricing guidance (E16 — follow the owner to every price). ONE component so cost, margin-vs-floor,
 * and the floor-hitting suggested price read identically wherever a price is set. `onApplySuggested`, when
 * given, makes the suggested price a one-tap set.
 */
export function PricingHint({
  cogs,
  price,
  floor,
  target = floor,
  onApplySuggested,
}: {
  cogs: number;
  price: number;
  floor: number;
  /** the margin the suggested price aims at; defaults to the floor (no change until the owner raises it). */
  target?: number;
  onApplySuggested?: (suggested: number) => void;
}) {
  const { margin, suggested, belowFloor } = pricingFor(cogs, price, floor, target);
  const floors = useMarginFloors();
  return (
    <div className="muted" style={{ fontSize: 12, lineHeight: 1.8 }}>
      بها: {formatRial(cogs)} · حاشیه:{' '}
      <b style={{ color: marginColor(margin, floors) }}>{formatPercent(margin)}</b>
      {belowFloor ? (
        <span className="warn" title={`زیر کف ${formatPercent(floor)}`}>
          {' '}
          ⚠
        </span>
      ) : null}
      {suggested > 0 ? (
        <>
          {' · '}
          <span title="قیمتی که دقیقاً به هدف حاشیهٔ سود می‌رسد: بها ÷ (۱ − هدف)">
            پیشنهاد (هدف {formatPercent(target)}):{' '}
          </span>
          {onApplySuggested ? (
            <button
              type="button"
              className="linklike"
              onClick={() => onApplySuggested(suggested)}
              title="گذاشتن این قیمت"
            >
              {formatRial(suggested)}
            </button>
          ) : (
            formatRial(suggested)
          )}
        </>
      ) : null}
    </div>
  );
}
